import { render, staticRenderFns } from "./Concedentes.vue?vue&type=template&id=62527c6e"
import script from "./Concedentes.vue?vue&type=script&lang=js"
export * from "./Concedentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports